import type {
  FormPackage,
  FormRoom,
  FormType,
  TimePeriod,
} from 'app/components/pages/Extranet/ExtranetInventory/Legacy/type';
import {
  completeOverviewPlanning,
  completePlanning,
} from 'app/components/pages/Extranet/ExtranetInventory/Legacy/utils';
import type { HotelInventory } from 'app/typings/Extranet/inventory';
import type { Hotel } from 'app/typings/hotels/Hotel/Hotel';
import type { ExtranetExperience, ExtranetPackage } from 'app/typings/packages';

export const formatInventory = (
  inventory: HotelInventory,
  timePeriod: TimePeriod,
  getExperiencesForPackage: (packageId: number) => ExtranetExperience[],
  packages: ExtranetPackage[],
  hasAtLeastOneDayPackage: boolean,
  hotelInfo?: Hotel
): FormType => ({
  packages:
    packages.reduce(
      (acc, pkg) => {
        acc[pkg.id] = completeOverviewPlanning(
          timePeriod,
          inventory.packages.filter((p) => p.packageId === pkg.id) ?? [
            {
              packageId: pkg.id,
              bookings: [],
            },
          ],
          pkg,
          inventory.rooms,
          hotelInfo
        );

        return acc;
      },
      {} as {
        [key: number]: FormPackage;
      }
    ) ?? [],
  rooms: inventory.rooms.reduce(
    (acc, room) => {
      acc[room.roomId] = completePlanning(
        timePeriod,
        room,
        packages ?? { packages: [] },
        getExperiencesForPackage,
        hotelInfo?.roomCount || 0,
        hasAtLeastOneDayPackage
      );

      return acc;
    },
    {} as {
      [key: number]: FormRoom;
    }
  ),
});
